import { ScrollArea } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const items = Array.from({ length: 40 }, (_, i) => `Tag ${String(i + 1).padStart(2, "0")}`);

export function ScrollAreaDemo() {
  return (
    <Section
      id="scroll-area"
      title="ScrollArea"
      description="Custom-scrollbar container. Use for chat logs, dialog bodies, command palettes."
    >
      <VariantBlock label="Vertical">
        <ScrollArea className="h-48 w-72 rounded-md border border-border">
          <div className="p-4 text-sm">
            <h4 className="mb-2 font-medium">Tags</h4>
            {items.map((label) => (
              <div
                key={label}
                className="border-b border-border py-1 last:border-0"
              >
                {label}
              </div>
            ))}
          </div>
        </ScrollArea>
      </VariantBlock>

      <VariantBlock label="Horizontal">
        <ScrollArea className="w-80 whitespace-nowrap rounded-md border border-border">
          <div className="flex gap-3 p-4">
            {items.slice(0, 14).map((label) => (
              <div
                key={label}
                className="shrink-0 rounded-md bg-muted px-3 py-2 text-sm"
              >
                {label}
              </div>
            ))}
          </div>
        </ScrollArea>
      </VariantBlock>
    </Section>
  );
}
